import { createMuiStyles } from '../../utils/mui';

export const eligibilityFailContentStyles = createMuiStyles({
  accordion: {
    boxShadow: 'none',
    my: '0!important',
  },
  accordionSummary: {
    borderTop: 1,
    borderRadius: 0,
    borderBottom: 1,
    borderColor: 'grey.200',
    px: 3,
    minHeight: 'auto!important',
    flexDirection: 'row-reverse',
    '.MuiAccordionSummary-content': {
      flexWrap: 'wrap',
      gap: 1,
      alignItems: 'center',
      justifyContent: 'space-between',
      my: `0.75rem!important`,
      ml: `.75rem!important`,
    },
  },
  accordionDetail: {
    p: 0,
    bgcolor: 'grey.50',
  },
  resultList: {
    '& > .MuiBox-root:not(:first-of-type)': {
      mt: 2.5,
      pt: 2.5,
      borderTop: 1,
      borderColor: 'grey.200',
    },
  },
});
